import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

const disabledStyles = css`
  cursor: default;
  pointer-events: none;
  background: ${COLORS.toggleOff};
`

export const ToggleSwitcherCircle = styled.div<{
  $isChecked: boolean
}>`
  width: 16px;
  aspect-ratio: 1/1;
  background: ${COLORS.surface};
  border-radius: ${RADII.pill};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  position: absolute;
  left: 2.5px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s ease;

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      transform: translateY(-50%) translateX(100%);
    `}
`

export const ToggleSwitcherWrapper = styled.div<{
  $isDisabled: boolean
  $isChecked: boolean
}>`
  flex-shrink: 0;
  position: relative;
  width: 37px;
  height: 20px;
  display: inline-flex;
  align-items: center;

  background-color: ${({ $isChecked }) =>
    $isChecked ? COLORS.primary : COLORS.toggleOff};
  border-radius: ${RADII.pill};

  transition: background-color 0.2s ease;

  cursor: pointer;

  ${({ $isDisabled }) => $isDisabled && disabledStyles}
`
